<template>
  <td class="border px-4 py-2 text-left [&[align=center]]:text-center [&[align=right]]:text-right">
    <slot />
  </td>
</template>
